/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespSidebarContact_displayInfo$ref: FragmentReference;
export type PdpRespSidebarContact_displayInfo = {|
  +pricing: ?{|
    +showSold: ?boolean,
    +showUnavailable: ?boolean,
  |},
  +$refType: PdpRespSidebarContact_displayInfo$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespSidebarContact_displayInfo",
  "type": "ItemDisplayInfo",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "pricing",
      "storageKey": null,
      "args": null,
      "concreteType": "PriceInfoDisplay",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "showSold",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "showUnavailable",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'f182d826b777d6b4adf124d05d0e1186';
module.exports = node;
